import { render } from "./LangSelector.vue?vue&type=template&id=71874472&ts=true"
import script from "./LangSelector.vue?vue&type=script&lang=ts"
export * from "./LangSelector.vue?vue&type=script&lang=ts"

import "./LangSelector.vue?vue&type=style&index=0&id=71874472&lang=css"

import exportComponent from "C:\\Users\\berge\\Desktop\\My Projects\\o2p-shop-planner\\SP.App\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__